import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  KEYWORDS: ({ commit, dispatch }, {projectId, params}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_KEYWORDS: ({ commit, dispatch }, {projectId, keywords}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords`, { keywords_name_and_period: keywords }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_KEYWORDS: ({ commit, dispatch }, {projectId, keywordsIds}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/delete`, { keyword_ids: keywordsIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_KEYWORDS: ({ commit, dispatch }, {projectId, count, page, fromDate, toDate}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/export`, { count: count, page: page, from_date: fromDate, to_date: toDate }, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_TAG: ({ commit, dispatch }, {projectId, keywordId, tag}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/${keywordId}/tag`, { tag: tag }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_TAGS: ({ commit, dispatch }, {projectId, keywordIds, tags}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/tags`, { keyword_ids: keywordIds, tags: tags }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_TAG: ({ commit, dispatch }, {projectId, keywordId, tag}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/${keywordId}/tag/delete`, { tag: tag }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  KEYWORDS_CHART: ({ commit, dispatch }, { projectId, params }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/${projectId}/keywords/chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/keyword/actions.js